import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  CommonFilter,
  Button,
  Tip,
  Spinner,
  ModalForm,
  ModalFormContainer,
  ModalFooter,
  ButtonCommonTheme,
  FormWrapper,
  FormColumn,
  FormGroup,
  ControlLabel,
  FormControl
} from "modules/theme";
import Select from "react-select-plus";
import {
  DataWrapperClass,
  InsightRow,
  InsightTitle,
  InsightWrapper,
} from "../styles/main";
import styled, { injectGlobal } from "styled-components";
import moment from "moment";
import { Modal, Tab, Tabs } from "react-bootstrap";
import LiveMonitorTileTheme from "./LiveMonitorTileTheme";
import DynamicAgTable from "./DynamicAgTable";
import DynamicCustomerTable from "./DynamicCustomerTable";
import LiveMonitorData from "./LiveMonitorData";
import { callAction, messageAction, globalAction } from "store/action";
import { connect } from "react-redux";
// import { globalStateSelector } from "store/selector";
import { confirm, Alert } from "modules/theme";
import { HeaderData } from "../../../../screens/reporting/styles";
import LiveMonitorService from "dialpad/service/livemonitor.service.js";
import Filter from "./Filter";
import { AdminDashboardWrapper } from "../../layout/components";
import DynamicReport from "./DynamicReports";
import Accordion from "./AccordionCommon.jsx";
import CommonManager from "../../../../../helpers/common";
import { chatSelector, globalStateSelector, livemonitorSelector } from "../../../../../store/selector/index.js";
import {
  getNameCall,
  getPlatform,
  getRole,
} from "../../../../screens/chatscreen/components/utils/generic.js";
import { RenderInitials } from "../../../../screens/chatscreen/components/Avatar/index.js";
import { buildMessage } from "../../../../../store/helper/call.helper.js";
import SummarySectionComponent from "./SummarySectionComponent.js";
import LiveMonitorTileChatTheme from "./LiveMonitorTileChatTheme.js";
import LiveMonitorTileChatMediumTheme from "./LiveMonitorTileChatMediumTheme.js";
import LiveMonitorChatData from "./LiveMonitorChatData.js";
import DynamicCustomerChatTable from "./DynamicCustomerChatTable.js.jsx";
import { localStore } from "../../../../../helpers/index.js";
import livemonitorAction from "../../../../../store/action/livemonitor.action.js";
import MessageRenderer from "../../../../screens/chatscreen/components/MessageRenderer/MessageRenderer.js";
import Chip from "../../../../screens/chatscreen/components/Chip/Chip.js";
const uuid = require("uuid");

injectGlobal`
  .header-title{
    line-height: 49px;
    font-size: 36px;
    font-weight: 700;
    margin-top: 30px;
    font-height: 49px;
    color: #2B3C93;
    letter-spacing: 0.1em;
    position: relative;
    bottom: 15px;
    left: 0;
  }

  .sidebar-title{
    margin-top: 20px;
    margin-left: 18px;
  }

  .transcriptData .msg {
    background: #F1F1F1;
    padding: 8px 16px 8px 16px;
    border-radius: 10px;
    word-wrap: break-word;
    color: #000;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }

  .contact-message-body-item {
    width: 100%;
    position: relative;
    padding: 30px;
    display: flex;
    flex: 1 1 auto;
    height: calc(100vh - 180px);
    flex-direction: column;
    overflow-y: auto;
    scroll-behavior: smooth;
    /* height: 400px; */
    overflow-x: hidden;
  }
  
  .contact-message-body-item__main {
    max-width: 100%;
    display: flex;
    margin: 6px;
    // /* width: 100%; */
    align-items: center;
    justify-content: end;
    flex-direction: row-reverse;
    gap: 10px;
  }
  
  .contact-message-body-item__inner {
    max-width: 70%;
    height: 100%;
    padding: 8px 16px 8px 16px;
    border-radius: 10px;
    /* box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15); */
    word-wrap: break-word;
    color: #000;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    display: flex;
    flex-direction: column;
    /* gap: 10px; */
    justify-content: center;
  }
  
  .contact-message-body-item__inner_display {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.01em;
    font-weight: 500;
    color: rgb(8, 15, 26);
  }
  .contact-message-body-item__customer {
  /* align-self: flex-start;
  flex-direction: row-reverse;
  justify-content: flex-end; */
  flex-direction: row;
  justify-content: flex-start;
  }
  
  .contact-message-body-item__agent {
  flex-direction: row-reverse;
  align-self: flex-end;
  }
  .contact-message-body-item__agent-bubble {
  background: #615EF0;
  /* margin-right: 1rem; */
  position: relative;
  /* color: #fff; */
  }
  
  .contact-message-body-item__agent-bubble .contact-msg {
  background: #615EF0;
  color: #fff !important;
  /* padding: 8px 16px 8px 16px; */
  border-radius: 10px;
  }
  
  .contact-message-body-item__customer-bubble .contact-msg {
  background: #F1F1F1;
  color: #000;
  /* padding: 8px 16px 8px 16px; */
  border-radius: 10px;
  }
  
  .contact-message-body-item__customer-bubble {
  background: #F1F1F1;
  /* margin-left: 1rem; */
  /* padding: 8px 16px 8px 12px; */
  position: relative;
  // color: #000;
  }
  
  .contact-message-body-item__flow{
  display: flex;
  align-self: flex-end;
  /* justify-content: flex-end; */
  }
  
  .contact-message-body-item__flow-bubble{
  /* margin-right: 1rem; */
  background-color: #f7f7f7;
  /* padding: 8px 16px 8px 12px; */
  }

  @media only screen and (max-width: 767px) {
    .header-title{
      font-size: 22px;
      padding-top: 10px;
    }
    .mainbox{
      margin-left: 20px !important;
      overflow: hidden;
    }
  }
`;

const TabItemsStyle = styled.div`
  height: 100%;
  width: 100%;
  .tabItemStyle {
    display: flex;
    // align-items: flex-end;
    // height: 52px;
    // padding: 0px 20px;
    // border-bottom: 1px solid rgb(226, 232, 239);
  }

  .tab-content,
  .tab-pane {
    height: 100%;
  }

  .tabItemStyle > div {
    width: 100%;
    // height: calc(100% - 8px);
    // display: flex;
    // -webkit-box-align: center;
    // align-items: center;
    // position: relative;
    // flex-flow: row-reverse wrap;
    // -webkit-box-pack: start;
    // justify-content: flex-start;
  }

  .tabItemStyle > div > ul {
    display: flex;
    flex-direction: row;
    -webkit-box-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    align-items: center;
    flex: 1 1 0%;
    border: none;
    border-bottom: 1px solid rgb(226, 232, 239);
    padding: 30px 20px 0px 20px;
  }

  ul > li > a {
    position: relative;
    padding: 3px 8px 12px;
    font-size: 14px;
    cursor: pointer;
    color: rgb(100, 116, 145);
    border: none !important;
    font-weight: 600;
    background: #fff;
    // border-bottom: 3px solid #fff !important;
  }

  ul > li.active > a,
  ul > li.active > a:focus,
  ul > li.active > a:hover {
    color: rgb(8, 15, 26) !important;
    border-bottom: 3px solid rgb(5, 102, 255) !important;
    background: #fff !important;
    font-weight: 600 !important;
  }

  li > a:hover {
    background: #fff !important;
  }
  // ul > li > a:hover {
  //   color: rgb(8, 15, 26);
  //   border-bottom: 1px solid rgb(5, 102, 255);
  // }
`;

const GridContainer = styled.div`
  // height: 100%;
  height: calc(
    100% -
      ${(props) => {
    console.log("propsfullscreen", props.fullScreen);
    return props.fullScreen ? "80px" : "145px";
  }}
  );
  // max-height: calc(100vh - 70px );
  // max-height: calc(100% - 145px );
  padding: 15px;
  padding-top: 0;
  flex-grow: 1;
  display: flex;

  .livepadding-box {
    height: 100%;
    width: 100%;
  }

  @media only screen and (max-width: 872px) {
    .livepadding-box {
      height: 100vh;
    }
  }

  .tabDifferentStyle {
    height: 100%;
  }

  .liveMonitorTabs {
    height: 100%;
  }

  .liveMonitorTabs {
    display: flex;
    flex-direction: column;
  }

  .tab-content {
    flex-grow: 1;
  }

  .tab-pane {
    height: 100%;
  }

  .tab-pane > .ag-theme-alpine {
    height: 100% !important;
  }
`;

const EmptyStateStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  padding: 70px;
  color: #888;
  gap: 10px;

  img {
    max-height: 260px;
    width: auto;
    margin: auto;
  }
`;

const commonManager = new CommonManager();
export class LiveMonitorTheme extends Component {
  constructor(props) {
    super(props);
    this.moduleName = "Live Monitor";
    this.timer = "";
    let serverStamp = props.timeStamp;
    this.getTime = this.getTime.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.monitorCall = this.monitorCall.bind(this);
    this.monitorTranscript = this.monitorTranscript.bind(this);
    this.monitorChat = this.monitorChat.bind(this);
    this.monitorChatInboundBlock = this.monitorChatInboundBlock.bind(this);
    this.monitorCallHangup = this.monitorCallHangup.bind(this);
    this.monitorCallInboundBlock = this.monitorCallInboundBlock.bind(this);
    this.getData = this.getData.bind(this);
    this.toggleFullScreen = this.toggleFullScreen.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleTabChatChange = this.handleTabChatChange.bind(this);
    this.getDataForReports = this.getDataForReports.bind(this);
    this.setToFalseShouldCallAPI = this.setToFalseShouldCallAPI.bind(this);
    this.refreshTimer = this.refreshTimer.bind(this);
    this.liveMonitor = new LiveMonitorService();
    this.showModalTable = this.showModalTable.bind(this);
    this.showChatModalTable = this.showChatModalTable.bind(this);
    this.showChatInboundBlockModalTable = this.showChatInboundBlockModalTable.bind(this);
    this.showCallInboundBlockModalTable = this.showCallInboundBlockModalTable.bind(this);
    this.showModalData = this.showModalData.bind(this);
    this.showChatModalData = this.showChatModalData.bind(this);
    this.conversationEndRef = React.createRef();
    this.messageContainerRef = React.createRef();
    this.chatContainerRef = React.createRef();
    this.transcriptRef = React.createRef(); // Create a ref for the transcript
    this.transcriptRef.current = this.props.transcript;
    this.chatEventCall = this.chatEventCall.bind(this);
    this.chatInboundBlockOptions = [
      { value: "platform", label: "Platform" },
      { value: "flow", label: "Flow" },
    ];
    this.callInboundBlockOptions = [
      { value: "global", label: "Global" },
      { value: "inboundPhoneNumber", label: "Inbound Phone Number" }
    ];
    this.state = {
      disableRefresh: false,
      fullScreen: false,
      serverStamp: serverStamp,
      isOpen: [],
      totalPerPage: 0,
      perPageCount: 10,
      currentPage: 1,
      loading: true,
      isActive: false,
      activeKey: 1,
      activeChatKey: 1,
      autoRefreshTimer: 0,
      liveMonitorTile: [
        {
          title: "Total Calls",
          count: 0,
          icon: (
            <img src="/images/icon/ic_total_call.svg" className="loadImg" />
          ),
        },
        {
          title: "Inbound Calls",
          count: 0,
          icon: (
            <img src="/images/icon/ic_inbound_call.svg" className="loadImg" />
          ),
        },
        {
          title: "Outbound Calls",
          count: 0,
          icon: (
            <img src="/images/icon/ic_outgoing_call.svg" className="loadImg" />
          ),
        },
      ],
      liveMonitorTileData: [
        { title: "Maximum Talktime", count: 0, icon: "/images/talktime.png" },
        {
          title: "Maximum Waiting Call",
          count: 0,
          icon: "/images/waitingcall.png",
        },
        {
          title: "Maximum Waiting Chat",
          count: 0,
          icon: "/images/waitingchat.png",
        },
      ],
      timers: [
        {
          value: 0,
          label: "OFF",
        },
        {
          value: 5,
          label: "5s",
        },
        {
          value: 10,
          label: "10s",
        },
        {
          value: 30,
          label: "30s",
        },
        {
          value: 45,
          label: "45s",
        },
        {
          value: 60,
          label: "1m",
        },
        {
          value: 300,
          label: "5m",
        },

        {
          value: 900,
          label: "15m",
        },

        {
          value: 1800,
          label: "30m",
        },
      ],
      APIReports: [
        {
          name: "User Summary",
          getDataAPI: "user/agent/performance/report",
          eventKey: 3,
          disableRefresh: false,
          refreshTimerIdentifier: "__DynamicUserSummary",
          selectedValues: {},
          reportFilter: {
            listConfig: {},
            limit: 10,
            page_no: 1,
            orderBy: "",
            order: "",
          },
          originalFilter: {
            listConfig: {},
            limit: 10,
            page_no: 1,
            orderBy: "",
            order: "",
          },
        },
        {
          name: "Provider Report",
          getDataAPI: "user/agent/provider/report",
          eventKey: 4,
          disableRefresh: false,
          refreshTimerIdentifier: "__DynamicProviderReport",
          selectedValues: {
            interval: "15",
          },
          reportFilter: {
            sendEndTime: "",
            interval: "15",
            timezone: {},
          },
          originalFilter: {
            sendEndTime: "",
            interval: "15",
            timezone: {},
          },
        },
        {
          name: "Carrier Status",
          getDataAPI: "user/agent/carrier/report",
          eventKey: 5,
          disableRefresh: false,
          refreshTimerIdentifier: "__DynamicCareerStatus",
          selectedValues: {},
          reportFilter: {},
          originalFilter: {},
        },
      ],
      showModal: false,
      showChatModal: false,
      showChatInboundModal: false,
      showCallInboundModal: false,
      scData: {},
      sChatData: {},
      callInfoData: {},
      chatInfoData: {},
      chatInboundInfoData: {},
      callInboundInfoData: {},
      chatInboundBlockType: "platform",
      callInboundBlockType: "global",
      transcript: [],
      userScrolled: false,
      userChatScrolled: false,
      loading: false,
    };
  }
  // componentDidMount() {
  //   // Initialize the transcript state with the current prop value
  //   this.setState({ transcript: this.props.transcript });
  // }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.transcript !== this.props.transcript) {
  //     this.setState({ transcript: this.props.transcript });
  //   }
  // }

  componentDidUpdate(prevProps) {
    // Scroll to the bottom only if user hasn't manually scrolled up
    if (this.props.transcript !== prevProps.transcript) {
      if (!this.state.userScrolled) {
        this.scrollToBottom();
      }
    }
    if (this.props.liveTranscription !== prevProps.liveTranscription) {
      if (!this.state.userChatScrolled) {
        this.scrollToBottomChat();
      }
    }
  }

  scrollToBottom = () => {
    const messageContainer = this.messageContainerRef.current;
    if (messageContainer) {
      // Scroll to the bottom
      messageContainer.scrollTop = messageContainer.scrollHeight;
    }
  };

  scrollToBottomChat = () => {
    const chatContainer = this.chatContainerRef.current;
    if (chatContainer) {
      // Scroll to the bottom
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  };

  handleScroll = () => {
    const messageContainer = this.messageContainerRef.current;
    if (messageContainer) {
      const isAtBottom =
        Math.abs(
          messageContainer.scrollHeight -
          messageContainer.scrollTop -
          messageContainer.clientHeight
        ) <= 1;

      // If user has scrolled up
      if (!isAtBottom) {
        this.setState({ userScrolled: true });
      } else {
        this.setState({ userScrolled: false }, () => {
          this.scrollToBottom(); // Ensure it scrolls to bottom if needed
        });
      }
    }
  };

  handleScrollChat = () => {
    const chatContainer = this.chatContainerRef.current;
    if (chatContainer) {
      const isAtBottom =
        Math.abs(
          chatContainer.scrollHeight -
          chatContainer.scrollTop -
          chatContainer.clientHeight
        ) <= 1;

      // If user has scrolled up
      if (!isAtBottom) {
        this.setState({ userChatScrolled: true });
      } else {
        this.setState({ userChatScrolled: false }, () => {
          this.scrollToBottomChat(); // Ensure it scrolls to bottom if needed
        });
      }
    }
  };

  toggleFullScreen(fullScreen) {
    this.setState({ fullScreen });
    this.forceUpdate();
  }

  showModalTable(showModal) {
    this.setState({ showModal: showModal });
    this.forceUpdate();
  }

  showChatModalTable(showChatModal) {
    console.log('showChatModal', showChatModal)
    this.setState({ showChatModal: showChatModal });
    // this.forceUpdate();
  }

  showChatInboundBlockModalTable(showChatInboundModal) {
    this.setState({ showChatInboundModal: showChatInboundModal });
  }

  showCallInboundBlockModalTable(showCallInboundModal) {
    this.setState({ showCallInboundModal: showCallInboundModal });
  }

  showModalData(data) {
    this.setState({ scData: data }, () => {
      // This callback is executed after the state is updated
      console.log("Updated scData:", this.state.scData);

      // If forceUpdate is necessary
      this.forceUpdate();
    });
  }

  showChatModalData(data) {
    this.setState({ sChatData: data }, () => {
      console.log('Update sChatData:', this.state.sChatData);
      // this.forceUpdate();
    })
  }

  ragRenderer(params) {
    return '<span class="rag-element">' + params.value + "</span>";
  }
  getTime(timeStamp) {
    let timeDiff = parseInt(this.state.serverStamp - timeStamp);
    timeDiff = timeDiff && timeDiff > 0 ? timeDiff : 0;
    let time = moment.utc(timeDiff * 1000).format("HH:mm:ss");
    return time;
  }
  // shouldComponentUpdate(nextProps, nextState) {
  //   return false;
  // }
  sendMessage(message) {
    const { emitSocketMessage } = this.props;
    emitSocketMessage("message-processor", message);
  }

  toggleFilter() {
    this.setState({ isActive: !this.state.isActive });
    this.forceUpdate();
  }

  monitorCall(params) {
    const { isConnected, userState, callProcess, dynamicUpdate } = this.props;
    let State = userState.State || "";
    console.log("monitorCall running", JSON.stringify(params));
    if (!isConnected) {
      console.log("You are not connected");
      Alert.error("Your dialpad is not connected");
      return;
    }
    if (State != "online") {
      console.log("User Not Online");
      if (State == "CONNECTED" || State == "CUSTOMER_RINING") {
        console.log("User On Call");
        Alert.error(
          "Please wait for the ongoing call to finish before attempting to barge in."
        );
        return;
      } else {
        Alert.error(
          "You are currently offline. Please go online to start barge in."
        );
        return;
      }
    }
    if (params.callInfo) {
      confirm("Do you want to bardge Call ?", {
        icon: "info",
        showConfirmation2: false,
      }).then((e) => {
        callProcess("monitorCall", params.callInfo);
      });
    } else {
      console.error(`[monitorCall] Call info not found`);
    }
  }

  // monitorCallInboundBlock(params) {
  //   const { isConnected, userState, callProcess, dynamicUpdate } = this.props;
  //   let State = userState.State || "";
  //   console.log("monitorCallInboundBlock running", JSON.stringify(params));
  //   if (!isConnected) {
  //     console.log("You are not connected");
  //     Alert.error("Your dialpad is not connected");
  //     return;
  //   }
  //   // if (State != "online") {
  //   //   console.log("User Not Online");
  //   //   if (State == "CONNECTED" || State == "CUSTOMER_RINING") {
  //   //     console.log("User On Call");
  //   //     Alert.error(
  //   //       "Please wait for the ongoing call to finish before attempting to barge in."
  //   //     );
  //   //     return;
  //   //   } else {
  //   //     Alert.error(
  //   //       "You are currently offline. Please go online to start barge in."
  //   //     );
  //   //     return;
  //   //   }
  //   // }
  //   if (params.callInfo) {
  //     confirm("Do you want to block inbound block Call ?", {
  //       icon: "info",
  //       showConfirmation2: false,
  //     }).then((e) => {
  //       callProcess("monitorCallInboundBlock", params.callInfo);
  //     });
  //   } else {
  //     console.error(`[monitorCallInboundBlock] Call info not found`);
  //   }
  // }

  monitorCallHangup(params) {
    const { isConnected, userState, callProcess, dynamicUpdate } = this.props;
    let State = userState.State || "";
    console.log("monitorHangup running", JSON.stringify(params));
    if (!isConnected) {
      console.log("You are not connected");
      Alert.error("Your dialpad is not connected");
      return;
    }
    // if (State != "online") {
    //   console.log("User Not Online");
    //   if (State == "CONNECTED" || State == "CUSTOMER_RINING") {
    //     console.log("User On Call");
    //     Alert.error(
    //       "Please wait for the ongoing call to finish before attempting to barge in."
    //     );
    //     return;
    //   } else {
    //     Alert.error(
    //       "You are currently offline. Please go online to start barge in."
    //     );
    //     return;
    //   }
    // }
    if (params.callInfo) {
      confirm("Do you want to hangup Call ?", {
        icon: "info",
        showConfirmation2: false,
      }).then((e) => {
        callProcess("monitorCallHangup", params.callInfo);
      });
    } else {
      console.error(`[monitorCallHangup] Call info not found`);
    }
  }

  monitorTranscript(params) {
    const { isConnected, userState, callProcess, dynamicUpdate } = this.props;
    console.log("userState, callProcess", userState, callProcess);
    let State = userState.State || "";
    console.log("monitorTranscript running", JSON.stringify(params));
    // if (!isConnected) {
    //   console.log("You are not connected");
    //   Alert.error("Your dialpad is not connected");
    //   return;
    // }
    // if (State != "online") {
    //   console.log("User Not Online");
    //   if (State == "CUSTOMER_CONNECTED" || State == "CUSTOMER_RINING") {
    //     console.log("User On Call");
    //     Alert.error(
    //       "Please wait for the ongoing call to finish before attempting to barge in."
    //     );
    //     return;
    //   }
    //   Alert.error(
    //     "Please wait for the ongoing call to finish before attempting to barge in."
    //   );
    //   return;
    // }
    if (params.callInfo) {
      // confirm("Do you want to bardge Call ?", {
      //   icon: "info",
      //   showConfirmation2: false,
      // }).then((e) => {
      //   callProcess("monitorCall", params.callInfo);
      // });
      callProcess("monitorTranscript", params.callInfo);
      this.setState({ callInfoData: params.callInfo });
    } else {
      console.error(`[monitorTranscript] Call info not found`);
      this.handleModalClose();
    }

    // if (params.callInfo) {
    //   confirm("Do you want to bardge Call ?", {
    //     icon: "info",
    //     showConfirmation2: false,
    //   }).then((e) => {
    //     callProcess("monitorCall", params.callInfo);
    //   });
    // } else {
    //   console.error(`[monitorCall] Call info not found`);
    // }
  }

  monitorChat(params) {
    // console.log("chatInfoDataaaa", JSON.stringify(params));
    if (params.id) {
      // callProcess("monitorChat", params.callInfo);
      this.setState({ chatInfoData: params });
    } else {
      console.error(`[monitorChat] Call info not found`);
    }
  }

  monitorChatInboundBlock(params) {
    // console.log("monitorChatInboundBlock", JSON.stringify(params));
    if (params.id) {
      // callProcess("monitorChatInboundBlock", params.callInfo);
      this.setState({ chatInboundInfoData: params });
    } else {
      console.error(`[monitorChatInboundBlock] Call info not found`);
    }
  }

  monitorCallInboundBlock(params) {
    // console.log("monitorCallInboundBlock", JSON.stringify(params));
    if (params.id) {
      // callProcess("monitorCallInboundBlock", params.callInfo);
      this.setState({ callInboundInfoData: params });
    } else {
      console.error(`[monitorCallInboundBlock] Call info not found`);
    }
  }

  renderTitle(title) {
    const { __ } = this.context;
    return;
  }

  getData(data) {
    let selectedTeam = [];
    let selectedUser = [];
    let selectedCampaign = [];
    if (data.selectedTeam && data.selectedTeam.length > 0) {
      data.selectedTeam.map((element) => {
        if (element.value) {
          selectedTeam.push(element.value);
        }
      });
    }

    if (data.selectedCampaign && data.selectedCampaign.length > 0) {
      data.selectedCampaign.map((element) => {
        if (element.value) {
          selectedCampaign.push(element.value);
        }
      });
    }

    if (data.selectedUser && data.selectedUser.length > 0) {
      data.selectedUser.map((element) => {
        if (element.value) {
          selectedUser.push(element.value);
        }
      });
    }

    let filter = {
      team: selectedTeam,
    };
    this.setState({
      Filters: filter,
      currentPage: 1,
      isActive: false,
      dataFilter: data,
    });
    this.forceUpdate();
    if (this.liveMonitor) {
      this.liveMonitor.defineFilter(filter);
    }
  }

  getDataForReports(data) {
    data = data || {};

    let tempData = {};

    for (let item in data) {
      if (Array.isArray(data[item])) {
        tempData[item] = data[item].map((element) => element.value || element);
      } else {
        tempData[item] = data[item];
      }
    }

    this.setState(
      {
        FiltersForReports: data,
        currentPageForReports: 1,
        isActive: false,
        APIReports: this.state.APIReports.map((report) => {
          if (this.state.activeKey === report.eventKey) {
            if (report.eventKey === 4 || report.eventKey === 5) {
              let { sendStartTime = "", startDate = "", ...reportFilter } = {
                ...report.originalFilter,
                ...tempData,
              };
              return {
                ...report,
                selectedValues: data,
                reportFilter,
              };
            } else {
              return {
                ...report,
                selectedValues: data,
                reportFilter: {
                  ...report.originalFilter,
                  ...tempData,
                },
              };
            }
          }
          return report;
        }),
        shouldCallAPI: true,
      },
      () => {
        console.log("tempdata state set", this.state.APIReports);
        this.forceUpdate();
      }
    );
  }

  setToFalseShouldCallAPI() {
    this.setState({ shouldCallAPI: false }, this.forceUpdate);
  }

  generateReportFilterFields() {
    if (this.state.activeKey === 3) {
      return [
        "renderUser",
        // "renderTeam",
        "renderTimezones",
        "renderDisposition",
      ];
    }
    if (this.state.activeKey === 4) {
      return [
        "renderEndDateOnly",
        "renderTimezonesOnly",
        "renderInterval",
        // "renderProvider"
      ];
    }
    if (this.state.activeKey === 5) {
      return ["renderEndDateOnly", "renderTimezonesOnly"];
    }
  }

  selectedColumnList() { }

  renderFilter() {
    console.log("render filter called");
    const { brands, history, queryParams } = this.props;
    return (
      <InsightWrapper>
        <HeaderData>
          <h6>Filter</h6>
          <div
            onClick={() => {
              if (this.state.isActive) {
                this.setState({ isActive: false });
                this.forceUpdate();
              }
            }}
            style={{ cursor: "pointer" }}
            className="filter-header-bar"
          >
            <span class="material-symbols-outlined">cancel</span>
          </div>
        </HeaderData>
        {this.state.activeKey === 1 || this.state.activeKey === 2 ? (
          <Filter
            style={{ zIndex: "999999" }}
            filterList={["renderTeam", "renderCampaign", "renderUser"]}
            getSelectedColumnNames={this.selectedColumnList}
            getData={this.getData}
            history={history}
            brands={[]}
            queryParams={this.state.dataFilter}
            selectedFilter={this.state.selectedFilter}
            setFilter={this.setFilter}
            updateFilter={this.updateFilter}
            TeamList={this.state.team}
          />
        ) : (
          <CommonFilter
            filterList={this.generateReportFilterFields()}
            endDatePickerOptions={{ timeFormat: false }}
            getSelectedColumnNames={() => { }}
            getData={this.getDataForReports}
            queryParams={this.state.FiltersForReports}
            selectedValues={
              this.state.APIReports[this.state.activeKey - 3].selectedValues
            }
            reportName={this.state.activeKey === 3 ? "User Summary" : ""}
            showAgentsOnly={true}
          />
        )}
      </InsightWrapper>
    );
  }

  handleRefreshTimerChange(e, timerRecieved) {
    this.setState(
      {
        // APIReports: this.state.APIReports.map((report) => {
        //   if (report.eventKey === this.state.activeKey) {
        //     return {
        //       ...report,
        //       autoRefreshTimer: timerRecieved.value,
        //     };
        //   }
        //   return report;
        // }),
        autoRefreshTimer: timerRecieved.value,
      },
      this.forceUpdate
    );
  }

  handleTabChange(activeKey) {
    if (this.state.activeKey === activeKey) return;
    let update = false;
    let zone = commonManager.getTimeZone();
    if (activeKey !== this.state.activeKey && activeKey === 3) {
      update = true;
    }
    if (update) {
      const { startDate, endDate } = commonManager.calculateTimeRange(
        "Today",
        zone
      );
      this.setState(
        {
          activeKey,
          APIReports: this.state.APIReports.map((report) => ({
            ...report,
            reportFilter: {
              ...report.originalFilter,
              DatesBy: "Today",
              timezone: zone,
            },
            selectedValues: {
              interval: "15",
              DatesBy: "Today",
              timezone: zone,
            },
          })),
          FiltersForReports: {
            DatesBy: "Today",
            timezone: zone,
            sendStartTime: startDate,
            sendEndTime: endDate,
            startDate: startDate,
            endDate: endDate,
          },
        },
        this.forceUpdate
      );
    } else {
      this.setState(
        {
          activeKey,
          APIReports: this.state.APIReports.map((report) => ({
            ...report,
            reportFilter: report.originalFilter,
            selectedValues: { interval: "15" },
          })),
        },
        this.forceUpdate
      );
    }
  }

  handleTabChatChange(activeChatKey) {
    if (this.state.activeChatKey === activeChatKey) return;
    let update = false;
    let zone = commonManager.getTimeZone();
    if (activeChatKey !== this.state.activeChatKey && activeChatKey === 3) {
      update = true;
    }
    if (update) {
      const { startDate, endDate } = commonManager.calculateTimeRange(
        "Today",
        zone
      );
      this.setState(
        {
          activeChatKey,
          APIReports: this.state.APIReports.map((report) => ({
            ...report,
            reportFilter: {
              ...report.originalFilter,
              DatesBy: "Today",
              timezone: zone,
            },
            selectedValues: {
              interval: "15",
              DatesBy: "Today",
              timezone: zone,
            },
          })),
          FiltersForReports: {
            DatesBy: "Today",
            timezone: zone,
            sendStartTime: startDate,
            sendEndTime: endDate,
            startDate: startDate,
            endDate: endDate,
          },
        },
        this.forceUpdate
      );
    } else {
      this.setState(
        {
          activeChatKey,
          APIReports: this.state.APIReports.map((report) => ({
            ...report,
            reportFilter: report.originalFilter,
            selectedValues: { interval: "15" },
          })),
        },
        this.forceUpdate
      );
    }
  }

  refreshTimer() {
    this.setState(
      {
        shouldCallAPI: true,
        // disableRefresh: true
        APIReports: this.state.APIReports.map((report) => {
          if (report.eventKey === this.state.activeKey) {
            return {
              ...report,
              disableRefresh: true,
            };
          }
          return report;
        }),
      },
      this.forceUpdate
    );
    setTimeout(() => {
      this.setState(
        {
          // disableRefresh: false
          APIReports: this.state.APIReports.map((report) => {
            if (report.eventKey === this.state.activeKey) {
              return {
                ...report,
                disableRefresh: false,
              };
            }
            return report;
          }),
        },
        this.forceUpdate
      );
    }, 30000);
  }

  renderAutoRefresh() {
    return (
      <Tip key="refresh-button" text={"Refresh"}>
        <button
          style={{ left: 360, marginTop: 8, backgroundColor: "#0000" }}
          className="position-absolute border-0 p-2"
          disabled={
            this.state.APIReports[this.state.activeKey - 3].disableRefresh
          }
          onClick={this.refreshTimer}
        >
          <span className="material-symbols-outlined m-0">refresh</span>
        </button>
      </Tip>
    );

    {
      /*

        <Accordion
      title={<span className="material-symbols-outlined">refresh</span>}
        >
        <span className="text-uppercase fs-normal fw-bold">
        Refresh Interval :
        <br />
        </span>
        {this.state.timers.map((timer) => (
          <label className="px-3 d-flex cursor-pointer" htmlFor={timer.label}>
          <input
          className="mx-3 mt-0"
          defaultChecked={
            // this.state.activeKey !== 1 && this.state.activeKey !== 2
            //   ? timer.value ===
            //     this.state.APIReports[this.state.activeKey - 3]
            //       .autoRefreshTimer
            //   : false
            this.state.autoRefreshTimer === timer.value
          }
          name="auto-refresh-timer"
          id={timer.label}
          type="radio"
          onChange={(e) => this.handleRefreshTimerChange(e, timer)}
          />
          {timer.label}
          </label>
        ))}
        </Accordion>
        */
    }
  }

  handleModalClose = () => {
    this.showModalTable(false);
    // this.setState({ transcript: [] });
    this.transcriptRef.current = []; // Clear the transcript ref
    this.state.callInfoData.status = "stop";
    this.props.callProcess("monitorTranscript", this.state.callInfoData);
    this.props.setSummaryLoading(false);
    this.props.clearSummary();
  };

  handleChatModalClose = () => {
    let { currentUser } = this.props;
    currentUser = currentUser || {};
    let chatInfoData = this.state.chatInfoData || {}
    this.showChatModalTable(false);
    this.props.setChatSummaryLoading(false);
    this.props.clearChatSummary();
    // this.setState({ transcript: [] });
    // this.chatRef.current = []; // Clear the transcript ref
    // this.state.chatInfoData.status = "stop";
    console.log('chatInfoDataaaa', chatInfoData)
    let dataBargeStartStop = {
      agent: { userId: currentUser.userId },
      userId: currentUser.userId,
      tenantId: localStore.getItem('selected-tenant'),
      eventMessage:
      {
        type: "bargeIn",
        from: "agent",
        status: false,
      },
      sessionId: chatInfoData.id,
      plateform: chatInfoData.medium,
      payloadType: "event"
    }
    this.props.configProcessor("sendPayload", {
      ...dataBargeStartStop,
      "rmq:pattern": "global:event",
    });
    this.props.clearLiveTranscription();
   
    // this.props.callProcess("monitorChat", this.state.chatInfoData);
  };

  // updateData = () => {
  //   this.setState({ transcript: this.props.transcript });
  // };

  handleChatInboundModalClose = () => {
    this.showChatInboundBlockModalTable(false);
  }

  handleChatInboundBlockSubmit = (e) => {
    e.preventDefault();
    let { currentUser } = this.props;
    currentUser = currentUser || {};
    let chatInboundInfoData = this.state.chatInboundInfoData || {}
    this.showChatInboundBlockModalTable(false);
    console.log('chatInboundInfoData', chatInboundInfoData, this.state.chatInboundBlockType)
    // if (isSessionIdMatched) {
    let dataBargeStartStop = {
      // agent:
      //     { userId: params.data.id, },
      userId: currentUser.userId,
      tenantId: localStore.getItem('selected-tenant'),
      // eventMessage:
      // {
      //     type: "inboundBlock",
      //     from: "admin",
      //     status: true,
      // },
      sessionId: chatInboundInfoData.id,
      plateform: chatInboundInfoData.medium,
      // platform: params.data.medium,
      // payloadType: "event",
      // identifier: params.data.identifier,
      chatInboundBlockType: this.state.chatInboundBlockType
    }
    console.log('dataBargeStartStop', dataBargeStartStop)
    this.props.configProcessor("chatInboundBlock", {
      ...dataBargeStartStop,
      "rmq:pattern": "global:event",
    });
    // confirm("Do you want to block inbound Chat ?", {
    //   icon: "info",
    //   showConfirmation2: false,
    // }).then((e) => {
    //   this.props.configProcessor("chatInboundBlock", {
    //     ...dataBargeStartStop,
    //     "rmq:pattern": "global:event",
    //   });
    // });
    // } else {
    //   console.log("No matching sessionId found in the list");
    // }
  }

  handleCallInboundModalClose = () => {
    this.showCallInboundBlockModalTable(false);
  }

  handleCallInboundBlockSubmit = (e) => {
    e.preventDefault();
    const { isConnected, userState, callProcess, dynamicUpdate } = this.props;
    let State = userState.State || "";
    if (!isConnected) {
      console.log("You are not connected");
      Alert.error("Your dialpad is not connected");
      return;
    }
    let callInboundInfoData = this.state.callInboundInfoData || {}
    this.showCallInboundBlockModalTable(false);
    console.log('callInboundInfoData', callInboundInfoData, this.state.callInboundBlockType)
    // if (isSessionIdMatched) {
    let dataBargeStartStop = {
      callId: callInboundInfoData.callInfo.callId,
      sessionId: callInboundInfoData.callInfo.sessionId,
      voiceInboundBlockType: this.state.callInboundBlockType
    }
    console.log('dataBargeStartStop', dataBargeStartStop)
    // this.props.configProcessor("chatInboundBlock", {
    //   ...dataBargeStartStop,
    //   "rmq:pattern": "global:event",
    // });
    callProcess("monitorCallInboundBlock", dataBargeStartStop);
    // confirm("Do you want to block inbound Chat ?", {
    //   icon: "info",
    //   showConfirmation2: false,
    // }).then((e) => {
    //   this.props.configProcessor("chatInboundBlock", {
    //     ...dataBargeStartStop,
    //     "rmq:pattern": "global:event",
    //   });
    // });
    // } else {
    //   console.log("No matching sessionId found in the list");
    // }
  }

  handleAnalyticsGeneration = (e) => {
    // Step 1: Set loading to true when starting the operation
    this.setState({ loading: true });
    this.props.setSummaryLoading(true);

    let call = {
      pattern: "monitorAnalytics",
      subtype: "monitorAnalytics",
      type: "callHandler",
      body: {
        sessionId: this.state.scData.callInfo.sessionId,
        callId: this.state.scData.callInfo.callId,
      },
      replayTo: "notification-to-ui",
    };
    call = buildMessage(call);
    console.log("monitorAnalytics call ", call);

    this.props.emitSocketMessage("message-processor", call);

    // Check for the summary periodically
    // this.checkForSummary();
  };

  handleMsgAnalyticsGeneration = (e) => {
    e.preventDefault();
    let { currentUser } = this.props;
    currentUser = currentUser || {};
    let chatInfoData = this.state.chatInfoData || {}
    console.log('chatInfoData', chatInfoData)
    // if (isSessionIdMatched) {
    // this.props.dynamicUpdate({ data: { key: `chatSummaryLoading_${chatInfoData.sessionId}`, value: true } });
    this.props.setChatSummaryLoading(true);
    // let dataBargeStartStop = {
    //   // agent:
    //   //     { userId: params.data.id, },
    //   userId: currentUser.userId,
    //   tenantId: localStore.getItem('selected-tenant'),
    //   eventMessage:
    //   {
    //     type: "analytics",
    //     from: "agent",
    //   },
    //   sessionId: chatInfoData.id,
    //   payloadType: "event",
    // }
    // console.log('dataBargeStartStop', dataBargeStartStop)
    // this.props.configProcessor("liveChatSummary", {
    //   ...dataBargeStartStop,
    //   "rmq:pattern": "global:event",
    // });

    let configInfo1 = {
      pattern: 'chat:send:payload',
      type: 'callHandler',
      body: {
        userId: currentUser.userId,
        tenantId: localStore.getItem('selected-tenant'),
        eventMessage:
        {
          type: "analytics",
          from: "agent",
        },
        sessionId: chatInfoData.id,
        plateform: chatInfoData.medium,
        payloadType: "event",
        "rmq:pattern": "global:event",
      },
      subtype: 'chat:send:payload',
      replayTo: 'notification-to-ui'
    };
    configInfo1 = buildMessage(configInfo1);
    if (this.props.emitSocketMessage) {
      this.props.emitSocketMessage(`message-processor`, configInfo1);
    }
    // this.props.dynamicUpdate({ data: { key: `chatSummaryLoading_${this.state.scData.callInfo.sessionId}`, value: true } });
    // this.props.configProcessor("sendPayload", {
    //   sessionId: this.state.scData.callInfo.sessionId,
    //   // callId: this.state.scData.callInfo.callId,
    //   payloadType: "event",
    //   "rmq:pattern": "global:event",
    //   eventMessage: {
    //     ...(selectedAssignedList && selectedAssignedList.eventMessage),
    //     from: "agent",
    //     type: "analytics",
    //   },
    // });
  }

  checkForSummary = () => {
    // Use an interval to check for the summary
    // const intervalId = setInterval(() => {
    // if (this.props.summary) {
    //   // If summary is available, set loading to false and stop checking
    //   this.setState({ loading: false });
    //   this.props.setSummaryLoading(false);
    //   clearInterval(intervalId); // Stop the interval after the summary is found
    // }
    //  else {
    //   // Continue showing the loading state
    //   this.setState({ loading: true });
    //   this.props.setSummaryLoading(true);
    // }
    // }, 4000);
  };

  chatEventCall = () => {
    let configInfo1 = {
      pattern: 'user:live:monitor:message',
      type: 'callHandler',
      body: {
        limit: 20,
        page_no: 0,
        ...this.filterList
      },
      subtype: 'user:live:monitor:message',
      replayTo: 'notification-to-ui'
    };
    configInfo1 = buildMessage(configInfo1);
    if (this.props.emitSocketMessage) {
      this.props.emitSocketMessage(`message-processor`, configInfo1);
    }

    let configInfo2 = {
      pattern: 'live:monitor:chat:stats',
      type: 'callHandler',
      body: {
        limit: 20,
        page_no: 0,
        ...this.filterList
      },
      subtype: 'live:monitor:chat:stats',
      replayTo: 'notification-to-ui'
    };
    configInfo2 = buildMessage(configInfo2);
    if (this.props.emitSocketMessage) {
      this.props.emitSocketMessage(`message-processor`, configInfo2);
    }
  }

  generateParamsFromArray(tData) {
    return tData.map((tD) => ({
      value: tD.value,
      label: tD.label,
    }));
  }


  render() {
    const { __ } = this.context;
    const breadcrumb = [{ title: __("Live Monitor"), link: "/live-monitor" }];
    const { plist = [], nlist = [], timeDiff, uuid } = this.props;
    const { fullScreen, showModal, showChatModal } = this.state;
    const { summary } = this.props;
    const { chatSummary } = this.props;

    console.log("this.state.scData", this.state.scData);

    console.log("showTranscriptData", this.props.liveTranscription);
    const content = (
      <GridContainer fullScreen={fullScreen}>
        <InsightRow className="livepadding-box">
          <div className="tabDifferentStyle">
            <Tabs
              className="liveMonitorTabs"
              onSelect={this.handleTabChange}
              activeKey={this.state.activeKey}
              id="uncontrolled-tab-example"
            >
              <Tab eventKey={1} title="Agent data">
                <DynamicAgTable isTimeUpdate={true} />
              </Tab>
              <Tab eventKey={2} title="Customer data">
                <DynamicCustomerTable
                  monitorCall={this.monitorCall}
                  monitorCallHangup={this.monitorCallHangup}
                  monitorCallInboundBlock={this.monitorCallInboundBlock}
                  showCallInboundBlockModalTable={this.showCallInboundBlockModalTable}
                  monitorTranscript={this.monitorTranscript}
                  isTimeUpdate={true}
                  fullScreen={fullScreen}
                  showModal={showModal}
                  scData={this.state.scData}
                  showModalTable={this.showModalTable}
                  showModalData={this.showModalData}
                // updateData={this.updateData}
                />
              </Tab>
              {/* {this.state.APIReports.map((tab) => (
                <Tab title={tab.name} eventKey={tab.eventKey}>
                  <DynamicReport
                    shouldCallAPI={this.state.shouldCallAPI}
                    isActive={this.state.activeKey === tab.eventKey}
                    refreshTimerIdentifier={tab.refreshTimerIdentifier}
                    getDataAPI={tab.getDataAPI}
                    autoRefreshTimer={this.state.autoRefreshTimer}
                    reportFilter={tab.reportFilter}
                    setToFalseShouldCallAPI={this.setToFalseShouldCallAPI}
                  />
                </Tab>
              ))} */}
            </Tabs>
          </div>
        </InsightRow>
      </GridContainer>
    );

    console.log('this.props.setChatSummaryLoading', this.props.chatSummaryLoading)

    const chatContent = (
      <GridContainer fullScreen={fullScreen}>
        <div className="livepadding-box">
          {/* <div className="tabDifferentStyle"> */}
          {/* <Tabs
              className="liveMonitorTabs"
              onSelect={this.handleTabChatChange}
              activeKey={this.state.activeChatKey}
              id="uncontrolled-tab-example"
            > */}
          {/* <Tab eventKey={1} title="Agent data">
                <DynamicAgTable isTimeUpdate={true} />
              </Tab> */}
          {/* <Tab eventKey={1} title="Customer data"> */}
          <DynamicCustomerChatTable
            monitorChat={this.monitorChat}
            isTimeUpdate={true}
            fullScreen={fullScreen}
            showChatModal={showChatModal}
            sChatData={this.state.sChatData}
            showChatModalTable={this.showChatModalTable}
            showChatModalData={this.showChatModalData}
            showChatInboundBlockModalTable={this.showChatInboundBlockModalTable}
            monitorChatInboundBlock={this.monitorChatInboundBlock}
          // updateData={this.updateData}
          />
          {/* </Tab> */}
          {/* {this.state.APIReports.map((tab) => (
                <Tab title={tab.name} eventKey={tab.eventKey}>
                  <DynamicReport
                    shouldCallAPI={this.state.shouldCallAPI}
                    isActive={this.state.activeKey === tab.eventKey}
                    refreshTimerIdentifier={tab.refreshTimerIdentifier}
                    getDataAPI={tab.getDataAPI}
                    autoRefreshTimer={this.state.autoRefreshTimer}
                    reportFilter={tab.reportFilter}
                    setToFalseShouldCallAPI={this.setToFalseShouldCallAPI}
                  />
                </Tab>
              ))} */}
          {/* </Tabs> */}
          {/* </div> */}
        </div>
      </GridContainer>
    );

    const options = {
      scales: {
        xAxes: [
          {
            stacked: true,
            gridLines: {
              display: false,
            },
            barPercentage: 0.1,
          },
        ],
        yAxes: [
          {
            stacked: true,
            gridLines: {
              display: false,
            },
            barPercentage: 0.1,
          },
        ],
      },
    };

    const userDetails = {};
    const longValueDetails = {};

    summary
      ? Object.keys(summary).forEach((key) => {
        if (key.startsWith("static__")) {
          const newKey = key.replace("static__", ""); // Remove 'static__' prefix
          const value = summary[key];

          // Check if value is long
          if (typeof value === "string" && value.length > 15) {
            longValueDetails[newKey] = value; // Store long value
          } else {
            userDetails[newKey] = value; // Store normal value
          }
        }
      })
      : "";


    const agentUserDetails = {};
    const agentLongValueDetails = {};

    chatSummary
      ? Object.keys(chatSummary).forEach((key) => {
        if (key.startsWith("static__")) {
          const newKey = key.replace("static__", ""); // Remove 'static__' prefix
          const value = chatSummary[key];

          // Check if value is long
          if (typeof value === "string" && value.length > 15) {
            agentLongValueDetails[newKey] = value; // Store long value
          } else {
            agentUserDetails[newKey] = value; // Store normal value
          }
        }
      })
      : "";

    return (
      <div className="heightClass">
        <DataWrapperClass>
          {this.state.isActive && this.renderFilter()}
          <span
            className={this.state.isActive ? "addClass" : "removeClass"}
            onClick={() => {
              if (this.state.isActive) {
                this.setState({ isActive: false });
                this.forceUpdate();
              }
            }}
          >
            <AdminDashboardWrapper
              isFullScreen={fullScreen}
              changeFullScreen={this.toggleFullScreen}
              allowFullScreen={true}
              header={<AdminDashboardWrapper.Header breadcrumb={breadcrumb} />}
              heading={
                <React.Fragment>
                  <h6>Live Monitor</h6>
                  {this.state.activeKey !== 1 &&
                    this.state.activeKey !== 2 &&
                    this.renderAutoRefresh()}
                </React.Fragment>
              }
              tabData={true}
              content={content}
              chatContent={chatContent}
              chatEventCall={this.chatEventCall}
              // filter={<LiveMonitorThemeFilter isActive={this.state.isActive} />}
              right={true}
              filterOnClick={
                this.state.activeKey === 1 || this.state.activeKey === 2
                  ? null
                  : this.toggleFilter
              }
              sidebar={
                <InsightRow className="leftdashboard livepadding-right-box">
                  <span className="sidebar-title">
                    <InsightTitle
                      headingColor="#2B3C93 !important"
                      className="boxsmall-title"
                    >
                      CALL & AGENT STATS
                    </InsightTitle>
                  </span>
                  <LiveMonitorTileTheme
                    loading={false}
                    data={this.state.liveMonitorTile}
                    options={options}
                  />
                  <hr style={{ marginTop: "15px", marginBottom: "15px" }} />
                  <LiveMonitorData />
                </InsightRow>
              }
              chatSidebar={
                <InsightRow className="leftdashboard livepadding-right-box">
                  <span className="sidebar-title">
                    <InsightTitle
                      headingColor="#2B3C93 !important"
                      className="boxsmall-title"
                    >
                      Chat STATS
                    </InsightTitle>
                  </span>
                  <LiveMonitorTileChatTheme
                    loading={false}
                    data={this.state.liveMonitorTile}
                    options={options}
                  />
                  <hr style={{ marginTop: "15px", marginBottom: "15px" }} />
                  <span className="sidebar-title">
                    <InsightTitle
                      headingColor="#2B3C93 !important"
                      className="boxsmall-title"
                    >
                      Medium STATS
                    </InsightTitle>
                  </span>
                  <LiveMonitorTileChatMediumTheme
                    loading={false}
                    data={this.state.liveMonitorTile}
                    options={options}
                  />
                  <hr style={{ marginTop: "15px", marginBottom: "15px" }} />
                  <LiveMonitorChatData />
                </InsightRow>
              }
            />
          </span>
        </DataWrapperClass>

        <Modal
          show={this.state.showModal}
          onHide={this.handleModalClose}
          bsSize="lg"
        >
          <Modal.Header>
            <Modal.Title>Message Transcription</Modal.Title>
            <span
              onClick={this.handleModalClose}
              style={{
                cursor: "pointer",
                color: "#010101",
                fontSize: "25px",
              }}
              className="material-symbols-outlined"
            >
              cancel
            </span>
          </Modal.Header>
          <TabItemsStyle>
            <div className="tabItemStyle h-100">
              <Tabs
                className="liveMonitorTabs"
                // onSelect={(eventKey) => this.handleReset(eventKey)}
                // style={{ marginTop: "15px", marginLeft: "15px" }}
                defaultActiveKey="conversation"
                id="uncontrolled-tab-example"
              >
                <Tab
                  eventKey="conversation"
                  title="Conversation"
                // onClick={this.handleTabClick}
                >
                  <Modal.Body className="overflow-auto">
                    <div>
                      <div
                        className="contact-message-body-item"
                        onScroll={this.handleScroll} // Add scroll event listener
                        ref={this.messageContainerRef} // Reference for scrolling
                        style={{ height: "calc(100vh - 180px)" }}
                      >
                        {this.props.transcript &&
                          this.props.transcript.length !== 0 ? (
                          this.props.transcript.map((data, i) => {
                            const message = data;
                            if (!message) {
                              return null;
                            }
                            if (message && message.from === "system") {
                              return <div></div>;
                            }
                            return (
                              <div
                                key={i}
                                className={`contact-message-body-item__main contact-message-body-item__${getRole(
                                  message
                                )}`}
                              >
                                <div className="position-relative">
                                  <RenderInitials
                                    text={getNameCall(data)}
                                    type={getPlatform(data)}
                                  />
                                </div>
                                <div
                                  className={`contact-message-body-item__inner contact-message-body-item__${getRole(
                                    message
                                  )}-bubble`}
                                >
                                  <p
                                    className="contact-msg"
                                    style={{
                                      whiteSpace: "pre-wrap",
                                      margin: "0px",
                                    }}
                                  >
                                    {message.content.text}
                                  </p>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <EmptyStateStyled>
                            <img src="/images/empty/no_transcript.png" />
                            <span>No Data Found</span>
                          </EmptyStateStyled>
                        )}
                      </div>
                      <div ref={this.conversationEndRef} />
                    </div>
                  </Modal.Body>
                </Tab>

                {this.props.transcript && this.props.transcript.length !== 0 && (
                  <Tab
                    eventKey="analytics"
                    title="Analytics"
                  // onClick={this.handleTabClick}
                  >
                    <Modal.Body className="overflow-auto">
                      <div>
                        <div
                          className="contact-message-body-item"
                          style={{
                            height: "calc(100vh - 180px)",
                            paddingTop: "0px",
                          }}
                        >
                          {Object.keys(summary).length !== 0 ? (
                            <div>
                              <div className="d-flex justify-end mt-3 mb-3">
                                {/* <Tip
                                  text={__("Regenrate Analyst")}
                                  key={`${"Regenrate Analyst"}`}
                                > */}
                                <Button
                                  className=""
                                  type="default"
                                  // onClick={(e) => {
                                  //   let call = {
                                  //     pattern: "monitorAnalytics",
                                  //     subtype: "monitorAnalytics",
                                  //     type: "callHandler",
                                  //     body: {
                                  //       sessionId: this.state.scData.callInfo
                                  //         .sessionId,
                                  //       callId: this.state.scData.callInfo.callId,
                                  //     },
                                  //     replayTo: "notification-to-ui",
                                  //     // status: data.status,
                                  //   };
                                  //   call = buildMessage(call);
                                  //   console.log("monitorAnalytics call ", call);
                                  //   this.props.emitSocketMessage(
                                  //     "message-processor",
                                  //     call
                                  //   );
                                  // }}
                                  onClick={this.handleAnalyticsGeneration}
                                  disabled={this.props.summaryLoading}
                                >
                                  {this.props.summaryLoading ? (
                                    <Spinner
                                      style={{
                                        height: "3px",
                                        marginTop: "-15px",
                                        padding: "10px",
                                        marginBottom: "10px",
                                      }}
                                    />
                                  ) : (
                                    "Regenerate Analytics"
                                  )}
                                </Button>

                                {/* </Tip> */}
                              </div>
                              <SummarySectionComponent
                                summary={summary}
                                userDetails={userDetails}
                                longValueDetails={longValueDetails}
                              />
                            </div>
                          ) : (
                            // <EmptyStateStyled>
                            //   <img src="/images/empty/no_transcript.png" />
                            //   <span>No Data Found</span>
                            // </EmptyStateStyled>
                            <div
                              className="w-100 text-center"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100%",
                              }}
                            >
                              {/* <Button
                                className="btn_style message-screen-footer__send-btn"
                                type="default"
                                // onClick={(e) => {
                                //   let call = {
                                //     pattern: "monitorAnalytics",
                                //     subtype: "monitorAnalytics",
                                //     type: "callHandler",
                                //     body: {
                                //       sessionId: this.state.scData.callInfo
                                //         .sessionId,
                                //       callId: this.state.scData.callInfo.callId,
                                //     },
                                //     replayTo: "notification-to-ui",
                                //     // status: data.status,
                                //   };
                                //   call = buildMessage(call);
                                //   console.log("monitorAnalytics call ", call);
                                //   this.props.emitSocketMessage(
                                //     "message-processor",
                                //     call
                                //   );
                                // }}
                                onClick={this.handleAnalyticsGeneration}
                                disabled={this.props.summaryLoading}
                              >
                                {this.props.summaryLoading ? (
                                  <Spinner
                                    style={{
                                      height: "3px",
                                      marginTop: "-15px",
                                      padding: "10px",
                                      marginBottom: "10px",
                                    }}
                                  />
                                ) : (
                                  "Generate Analytics"
                                )}
                              </Button> */}
                              {!this.props.summaryLoading ? (
                                <Button
                                  className=""
                                  type="default"
                                  onClick={this.handleAnalyticsGeneration}
                                  disabled={this.props.summaryLoading}
                                >
                                  {/* {this.props.summaryLoading ? (
                                      <Spinner
                                        style={{
                                          height: "3px",
                                          marginTop: "-15px",
                                          padding: "10px",
                                          marginBottom: "10px",
                                        }}
                                      />
                                    ) : ( */}
                                  Generate Analytics
                                  {/* )} */}
                                </Button>
                              ) : (
                                <div className="loading-content">
                                  <img
                                    src="/images/icons/loader-alt-alt.gif"
                                    alt="stream robot"
                                    style={{
                                      filter: "invert() hue-rotate(90deg)",
                                    }}
                                  />
                                  <div>Please wait</div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </Modal.Body>
                  </Tab>
                )}
              </Tabs>
            </div>
          </TabItemsStyle>
        </Modal>

        <Modal
          show={this.state.showChatModal}
          onHide={this.handleChatModalClose}
          bsSize="lg"
        >
          <Modal.Header>
            <Modal.Title>Chat Barging</Modal.Title>
            <span
              onClick={this.handleChatModalClose}
              style={{
                cursor: "pointer",
                color: "#010101",
                fontSize: "25px",
              }}
              className="material-symbols-outlined"
            >
              cancel
            </span>
          </Modal.Header>
          <TabItemsStyle>
            <div className="tabItemStyle h-100">
              <Tabs
                className="liveMonitorTabs"
                // onSelect={(eventKey) => this.handleReset(eventKey)}
                // style={{ marginTop: "15px", marginLeft: "15px" }}
                defaultActiveKey="conversation"
                id="uncontrolled-tab-example"
              >
                <Tab
                  eventKey="conversation"
                  title="Conversation"
                // onClick={this.handleTabClick}
                >
                  <Modal.Body className="overflow-auto">
                    <div>
                      <div
                        className="contact-message-body-item"
                        onScroll={this.handleScrollChat} // Add scroll event listener
                        ref={this.chatContainerRef} // Reference for scrolling
                        style={{ height: "calc(100vh - 180px)", padding: '15px', minHeight: "calc(100vh - 180px)" }}
                      >
                        {this.props.liveTranscription &&
                          this.props.liveTranscription.length !== 0 ? (
                          this.props.liveTranscription.map((data, i) => {
                            const message = data.message;
                            console.log('messageData', message)
                            // if (!message || !message.content || typeof message.content.text !== "string") {
                            //   return null; // Skip rendering if message or message.content.text is invalid
                            // }
                            if (!message || !message.type) {
                              return null;
                            }
                            if (message && message.from === 'agent' && message.type === "typing") {
                              return null;
                            }
                            if (message.type === 'typing') {
                              return null;
                            }
                            if (message && message.from === "system") {
                              // return <div></div>;
                              return (
                                <div className="d-flex justify-content-center m-3" key={message.id} abc={message.id}>
                                  <Chip text={message && message.content && message.content.text} />
                                </div>
                              );
                            }
                            return (
                              <div
                                key={i}
                                className={`contact-message-body-item__main contact-message-body-item__${getRole(
                                  message
                                )}`}
                              >
                                <div className="position-relative">
                                  <RenderInitials
                                    text={getNameCall(message)}
                                    type={getPlatform(message)}
                                  />
                                </div>
                                <MessageRenderer
                                  message={message}
                                  sent={false}
                                  translate={false}
                                />
                              </div>
                            );
                          })
                        ) : (
                          <EmptyStateStyled>
                            <img src="/images/empty/no_transcript.png" />
                            <span>No Data Found</span>
                          </EmptyStateStyled>
                        )}
                      </div>
                      <div ref={this.conversationEndRef} />
                    </div>
                  </Modal.Body>
                </Tab>

                {this.props.liveTranscription && this.props.liveTranscription.length !== 0 && (
                  <Tab
                    eventKey="analytics"
                    title="Analytics"
                  // onClick={this.handleTabClick}
                  >
                    <Modal.Body className="overflow-auto">
                      <div>
                        <div
                          className="contact-message-body-item"
                          style={{
                            height: "calc(100vh - 180px)",
                            paddingTop: "0px",
                          }}
                        >
                          {Object.keys(chatSummary).length !== 0 ? (
                            <div>
                              <div className="d-flex justify-end mt-3 mb-3">
                                <Button
                                  className=""
                                  type="default"
                                  onClick={this.handleMsgAnalyticsGeneration}
                                  disabled={this.props.chatSummaryLoading}
                                >
                                  {this.props.chatSummaryLoading ? (
                                    <Spinner
                                      style={{
                                        height: "3px",
                                        marginTop: "-15px",
                                        padding: "10px",
                                        marginBottom: "10px",
                                      }}
                                    />
                                  ) : (
                                    "Regenerate Analytics"
                                  )}
                                </Button>
                              </div>
                              <SummarySectionComponent
                                summary={chatSummary}
                                userDetails={agentUserDetails}
                                longValueDetails={agentLongValueDetails}
                              />
                            </div>
                          ) : (
                            <div
                              className="w-100 text-center"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "100%",
                              }}
                            >
                              {!this.props.chatSummaryLoading ? (
                                <Button
                                  className=""
                                  type="default"
                                  onClick={this.handleMsgAnalyticsGeneration}
                                  disabled={this.props.chatSummaryLoading}
                                >
                                  Generate Analytics
                                </Button>
                              ) : (
                                <div className="loading-content">
                                  <img
                                    src="/images/icons/loader-alt-alt.gif"
                                    alt="stream robot"
                                    style={{
                                      filter: "invert() hue-rotate(90deg)",
                                    }}
                                  />
                                  <div>Please wait</div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </Modal.Body>
                  </Tab>
                )}
              </Tabs>
            </div>
          </TabItemsStyle>
        </Modal>

        <Modal
          show={this.state.showChatInboundModal}
          onHide={this.handleChatInboundModalClose}
          bsSize="md"
        >
          <Modal.Header>
            <Modal.Title>Chat Inbound Block</Modal.Title>
            <span
              onClick={this.handleChatInboundModalClose}
              style={{
                cursor: "pointer",
                color: "#010101",
                fontSize: "25px",
              }}
              className="material-symbols-outlined"
            >
              cancel
            </span>
          </Modal.Header>
          <Modal.Body >
            <ModalForm onSubmit={(e) => this.handleChatInboundBlockSubmit(e)}>
              <ModalFormContainer style={{ paddingTop: '15px' }}>
                <FormWrapper>
                  {/* <FormColumn style={{ marginTop: '10px' }}>
                    <FormGroup>
                      <ControlLabel required>Choose Inbound Block Type</ControlLabel>
                      <Select
                        defaultValue=""
                        placeholder="Select Inbound Block Type"
                        onChange={(item) => {
                          if (item) {
                            this.setState({ chatInboundBlockType: item.value || "platform" });
                          } else {
                            this.setState({ chatInboundBlockType: null });
                          }
                        }}
                        disabled={this.state.disabled}
                        value={this.state.chatInboundBlockType}
                        options={this.generateParamsFromArray(this.chatInboundBlockOptions)}
                      />
                    </FormGroup>
                  </FormColumn> */}
                  <FormColumn style={{ marginTop: '10px' }}>
                    <FormGroup style={{ marginBottom: '20px' }}>
                      <ControlLabel required className="mb-4">Choose Inbound Block Type</ControlLabel>
                      <div className="d-flex align-items-center">
                        <FormColumn style={{ paddingRight: '0' }}>
                          <FormControl
                            disabled={false}
                            defaultChecked={true}
                            componentClass="radio"
                            name="chatInboundBlockType"
                            id="chatInboundBlockTypePlatform"
                            checked={this.state.chatInboundBlockType === "platform"}
                            onChange={() => this.setState({ chatInboundBlockType: "platform" })}
                          >
                            Platform
                          </FormControl>
                        </FormColumn>
                        <FormColumn style={{ paddingRight: '0' }}>
                          <FormControl
                            disabled={false}
                            defaultChecked={true}
                            componentClass="radio"
                            name="chatInboundBlockType"
                            id="chatInboundBlockTypeFlow"
                            checked={this.state.chatInboundBlockType === "flow"}
                            onChange={() => this.setState({ chatInboundBlockType: "flow" })}
                          >
                            Flow
                          </FormControl>
                        </FormColumn>
                      </div>
                      {/* <Select
                                                              defaultValue=""
                                                              placeholder="Select Inbound Block Type"
                                                              onChange={(item) => {
                                                                  if (item) {
                                                                      this.setState({ chatInboundBlockType: item.value || "platform" });
                                                                  } else {
                                                                      this.setState({ chatInboundBlockType: null });
                                                                  }
                                                              }}
                                                              disabled={this.state.disabled}
                                                              value={this.state.chatInboundBlockType}
                                                              options={this.generateParamsFromArray(this.chatInboundBlockOptions)}
                                                          /> */}
                    </FormGroup>
                  </FormColumn>
                </FormWrapper>
              </ModalFormContainer>
              <ModalFooter>
                <ButtonCommonTheme
                  type='greyModalBtn'
                  modalBtnTitle='Cancel'
                  OnClick={() => { this.setState({ chatInboundBlockType: null, showChatInboundModal: false }) }}
                />
                <ButtonCommonTheme
                  type='blueModalBtn'
                  btnType='submit'
                  modalBtnTitle={'Send'}
                />
              </ModalFooter>
            </ModalForm>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.showCallInboundModal}
          onHide={this.handleCallInboundModalClose}
          bsSize="md"
        >
          <Modal.Header>
            <Modal.Title>Call Inbound Block</Modal.Title>
            <span
              onClick={this.handleCallInboundModalClose}
              style={{
                cursor: "pointer",
                color: "#010101",
                fontSize: "25px",
              }}
              className="material-symbols-outlined"
            >
              cancel
            </span>
          </Modal.Header>
          <Modal.Body >
            <ModalForm onSubmit={(e) => this.handleCallInboundBlockSubmit(e)}>
              <ModalFormContainer style={{ paddingTop: '15px' }}>
                <FormWrapper>
                  <FormColumn style={{ marginTop: '10px' }}>
                    <FormGroup style={{ marginBottom: '20px' }}>
                      <ControlLabel required className="mb-4">Choose Inbound Block Type</ControlLabel>
                      <div className="d-flex align-items-center">
                        <FormColumn style={{ paddingRight: '0' }}>
                          <FormControl
                            disabled={false}
                            defaultChecked={true}
                            componentClass="radio"
                            name="voiceInboundBlockType"
                            id="voiceInboundBlockTypeGlobal"
                            checked={this.state.voiceInboundBlockType === "global"}
                            onChange={() => this.setState({ voiceInboundBlockType: "global" })}
                          >
                            Global
                          </FormControl>
                        </FormColumn>
                        <FormColumn style={{ paddingRight: '0' }}>
                          <FormControl
                            disabled={false}
                            defaultChecked={true}
                            componentClass="radio"
                            name="voiceInboundBlockType"
                            id="voiceInboundBlockTypeInboundPhoneNumber"
                            checked={this.state.voiceInboundBlockType === "inboundPhoneNumber"}
                            onChange={() => this.setState({ voiceInboundBlockType: "inboundPhoneNumber" })}
                          >
                            Inbound Phone Number
                          </FormControl>
                        </FormColumn>
                      </div>
                      {/* <Select
                                                                            defaultValue=""
                                                                            placeholder="Select Inbound Block Type"
                                                                            onChange={(item) => {
                                                                                if (item) {
                                                                                    this.setState({ chatInboundBlockType: item.value || "platform" });
                                                                                } else {
                                                                                    this.setState({ chatInboundBlockType: null });
                                                                                }
                                                                            }}
                                                                            disabled={this.state.disabled}
                                                                            value={this.state.chatInboundBlockType}
                                                                            options={this.generateParamsFromArray(this.chatInboundBlockOptions)}
                                                                        /> */}
                    </FormGroup>
                  </FormColumn>
                </FormWrapper>
              </ModalFormContainer>
              <ModalFooter>
                <ButtonCommonTheme
                  type='greyModalBtn'
                  modalBtnTitle='Cancel'
                  OnClick={() => { this.setState({ callInboundBlockType: null, showCallInboundModal: false }) }}
                />
                <ButtonCommonTheme
                  type='blueModalBtn'
                  btnType='submit'
                  modalBtnTitle={'Send'}
                />
              </ModalFooter>
            </ModalForm>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

LiveMonitorTheme.contextTypes = {
  __: PropTypes.func,
};

const stateToProps = (state) => {
  console.log("stateToProps", globalStateSelector.getTranscriptionSet(state));
  return {
    currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' }),
    isConnected: globalStateSelector.getIsConnected(state),
    userState: globalStateSelector.getState(state),
    onCall: globalStateSelector.getOnCall(state),
    transcript: globalStateSelector.getTranscriptionSet(state),
    summary: globalStateSelector.getSummary(state),
    summaryLoading: globalStateSelector.getSummaryLoading(state),
    liveTranscription: livemonitorSelector.getLiveTranscriptionSet(state, { key: "liveTranscription" }),
    chatSummary: livemonitorSelector.getChatSummary(state, { key: "chatSummary" }),
    chatSummaryLoading: livemonitorSelector.getChatSummaryLoading(state, { key: "chatSummaryLoading" }),
  };
};

const dispatchToProps = (dispatch) => ({
  emitSocketMessage: (type, messageData) => {
    dispatch(messageAction.emitSocketMessage(type, messageData));
  },
  callProcess: (type, messageData) => {
    dispatch(callAction.process(type, messageData));
  },
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (data) => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
  clearSummary: () => dispatch(callAction.clearSummary()),
  setSummaryLoading: (data) => dispatch(callAction.setSummaryLoading({ data })),
  clearLiveTranscription: () => dispatch(livemonitorAction.clearLiveTranscription()),
  setChatSummaryLoading: (data) => dispatch(livemonitorAction.setChatSummaryLoading({ data })),
  clearChatSummary: () => dispatch(livemonitorAction.clearChatSummary()),
});
export default connect(stateToProps, dispatchToProps)(LiveMonitorTheme);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/LiveMonitorTheme.js